import { render } from "./MSelectBox.vue?vue&type=template&id=c8dca6c6"
import script from "./MSelectBox.vue?vue&type=script&lang=ts"
export * from "./MSelectBox.vue?vue&type=script&lang=ts"
script.render = render

export default script